import {
  getProjectAssetUrl,
  getProjectAssetsBaseUrl,
  ProjectDictionary,
  PublicProjectImage,
  PublicProjectSummary,
} from "@ecologi/shared";

const projectAssetsBucket = process.env.NEXT_PUBLIC_PROJECT_ASSETS_BUCKET;
const projectAssetsBaseUrl = projectAssetsBucket
  ? getProjectAssetsBaseUrl(projectAssetsBucket)
  : null;

export const getPublicProjectAssetUrl = (imageKey: string): string => {
  if (!projectAssetsBaseUrl) return imageKey;

  return getProjectAssetUrl(imageKey, projectAssetsBaseUrl);
};

export const resolvePublicProjectAssetUrls = <
  T extends Pick<PublicProjectSummary, "images" | "primaryImage">
>(
  project: T
): T => ({
  ...project,
  images: project.images.map((image) => ({
    ...image,
    imageKey: getPublicProjectAssetUrl(image.imageKey),
  })),
  primaryImage: project.primaryImage
    ? {
        ...project.primaryImage,
        imageKey: getPublicProjectAssetUrl(project.primaryImage.imageKey),
      }
    : null,
});

export const resolveProjectDictionaryAssetUrls = (
  dictionary: ProjectDictionary
): ProjectDictionary => ({
  ...dictionary,
  projects: Object.fromEntries(
    Object.entries(dictionary.projects).map(([id, project]) => [
      id,
      resolvePublicProjectAssetUrls(project),
    ])
  ),
});

export const resolvePublicProjectsAssetUrls = <T extends PublicProjectSummary>(
  projects: T[]
): T[] => projects.map(resolvePublicProjectAssetUrls);

export const getPrimaryProjectImageUrl = (
  project: Pick<PublicProjectSummary, "primaryImage" | "images">
): string =>
  project.primaryImage?.imageKey
    ? getPublicProjectAssetUrl(project.primaryImage.imageKey)
    : (project.images[0] as PublicProjectImage | undefined)?.imageKey
    ? getPublicProjectAssetUrl(project.images[0].imageKey)
    : "";
